export default [
  {
    value: 0,
    IGQE: '無棋力',
    TW: '無棋力',
    ROC: '無棋力',
    WEIQI: '無棋力',
    TSF: '無棋力',
    MY: '無棋力',
    HK: '無棋力',
    SF: '無棋力',
  },
  {
    value: 1,
    IGQE: 'G19',
    MY: '30K',
    HK: '30K',
    SF: '30K',
  },
  {
    value: 2,
    IGQE: 'G18',
  },
  {
    value: 3,
    IGQE: 'G17',
  },
  {
    value: 4,
    IGQE: 'G16',
  },
  {
    value: 5,
    IGQE: 'G15',
  },
  {
    value: 6,
    IGQE: 'G14',
    MY: '25K',
    HK: '25K',
    SF: '25K',
  },
  {
    value: 7,
    IGQE: 'G13',
  },
  {
    value: 8,
    IGQE: 'G12',
  },
  {
    value: 9,
    IGQE: 'G11',
  },
  {
    value: 10,
    IGQE: 'G10',
  },
  {
    value: 11,
    IGQE: 'G9',
    ROC: '丁組',
    MY: '20K',
    HK: '20K',
    SF: '20K',
  },
  {
    value: 12,
    IGQE: 'G8',
  },
  {
    value: 13,
    IGQE: 'G7',
  },
  {
    value: 14,
    IGQE: 'G6',
  },
  {
    value: 15,
    IGQE: 'G5',
  },
  {
    value: 16,
    IGQE: 'G4',
    ROC: '丙組',
    MY: '15K',
    HK: '15K',
    SF: '15K',
  },
  {
    value: 17,
    IGQE: 'G3',
  },
  {
    value: 18,
    IGQE: 'G2',
  },
  {
    value: 19,
    IGQE: 'G1',
  },
  {
    value: 20,
  },
  {
    value: 21,
    ROC: '乙組',
    MY: '10K',
    HK: '10K',
    SF: '10K',
  },
  {
    value: 22,
    MY: '9K',
    HK: '9K',
    SF: '9K',
  },
  {
    value: 23,
    MY: '8K',
    HK: '8K',
    SF: '8K',
  },
  {
    value: 24,
    MY: '7K',
    HK: '7K',
    SF: '7K',
  },
  {
    value: 25,
    MY: '6K',
    HK: '6K',
    SF: '6K',
  },
  {
    value: 26,
    ROC: '甲組',
    MY: '5K',
    HK: '5K',
    SF: '5K',
  },
  {
    value: 27,
    MY: '4K',
    HK: '4K',
    SF: '4K',
  },
  {
    value: 28,
    MY: '3K',
    HK: '3K',
    SF: '3K',
  },
  {
    value: 29,
    MY: '2K',
    HK: '2K',
    SF: '2K',
  },
  {
    value: 30,
    MY: '1K',
    HK: '1K',
    SF: '1K',
  },
  {
    value: 31,
    TW: '初段',
    ROC: '初段',
    WEIQI: '初段',
    TSF: '初段',
    MY: '1D',
    HK: '1D',
    SF: '1D',
  },
  {
    value: 32,
    TW: '二段',
    ROC: '二段',
    WEIQI: '二段',
    TSF: '二段',
    MY: '2D',
    HK: '2D',
    SF: '2D',
  },
  {
    value: 33,
    TW: '三段',
    ROC: '三段',
    WEIQI: '三段',
    TSF: '三段',
    MY: '3D',
    HK: '3D',
    SF: '3D',
  },
  {
    value: 34,
    TW: '四段',
    ROC: '四段',
    WEIQI: '四段',
    TSF: '四段',
    MY: '4D',
    HK: '4D',
    SF: '4D',
  },
  {
    value: 35,
    TW: '五段',
    ROC: '五段',
    WEIQI: '五段',
    TSF: '五段',
    MY: '5D',
    HK: '5D',
    SF: '5D',
  },
  {
    value: 36,
    TW: '六段',
    ROC: '六段',
    WEIQI: '六段',
    TSF: '六段',
    MY: '6D',
    HK: '6D',
    SF: '6D',
  },
  {
    value: 37,
    TW: '七段',
    ROC: '七段',
    WEIQI: '七段',
    TSF: '七段',
    MY: '7D',
    HK: '7D',
    SF: '7D',
  },
  {
    value: 38,
  },
  {
    value: 39,
  },
];
